import { getAllRetailerWeekIDs } from 'src/utils/dateformatting';

export default function parseAllWeekIds(allWeekIdsByRetailerId) {
  // find the common week IDs for all retailers and add as rid=0 (all retailers)
  const allUnion = getAllRetailerWeekIDs(allWeekIdsByRetailerId);
  allWeekIdsByRetailerId[0] = allUnion;

  return allWeekIdsByRetailerId;
}
